/**
 * FIX-274: spare part status groups. The DB CHECK spare_parts_status_check
 * and the take_out_spare_part / undo_take_out functions use the same values.
 */
export const IN_STOCK_STATUSES = ["pending_placement", "stored"] as const;
export const EXIT_STATUSES = ["used_in_repair", "sold", "scrapped"] as const;
export type ExitStatus = (typeof EXIT_STATUSES)[number];

export function isInStock(status: string | null | undefined): boolean {
  return (IN_STOCK_STATUSES as readonly string[]).includes(status ?? "");
}

export function isTakenOut(status: string | null | undefined): status is ExitStatus {
  return (EXIT_STATUSES as readonly string[]).includes(status ?? "");
}

/** FIX-298: the one look the part page shows for a part's stock state. */
export type PartStockState = "inStock" | "notInBin" | "takenOut" | "damaged";

export function partStockState(
  status: string | null | undefined,
  extractionStatus: string | null | undefined,
  binId: string | null | undefined,
): PartStockState {
  if (status === "damaged" || extractionStatus === "damaged") return "damaged";
  if (isTakenOut(status)) return "takenOut";
  if (status === "stored" && binId) return "inStock";
  return "notInBin";
}
